module.exports = __webpack_public_path__ + "img/AO.55a0e376.svg";